export default {
  intro: 'Veuillez suivre les étapes indiquées sur le terminal de paiement situé à votre droite.',
};